<template>
  <b-form-checkbox-group
    v-model="local_value"
    :options="options"
    name="select-tipos-instituicoes"
    stacked
  ></b-form-checkbox-group>
</template>

<script>
import SelectMulti from "@/components/Form/SelectMulti.vue";
import { mapActions } from "vuex";
import { map } from "lodash";
export default {
  props: {
    value: {
      default: [],
    },
  },
  components: { SelectMulti },
  data: () => ({
    tipos_instituicoes: [],
  }),
  computed: {
    local_value: {
      set(value) {
        let emit_value = [];
        value.forEach((id) => {
          emit_value.push({ id: id });
        });
        this.$emit("input", emit_value);
      },
      get() {
        let response = [];
        if (Array.isArray(this.value)) {
          response = _.map(this.value, "id");
        }
        return response;
      },
    },
    options() {
      return map(this.tipos_instituicoes, function (obj) {
        return {
          text: obj.nome,
          value: obj.id,
        };
      });
    },
  },
  methods: {
    ...mapActions("tipos_instituicoes", ["ActionFind"]),
  },

  async created() {
    let tipos_instituicoes = await this.ActionFind({per_page: 100});
    this.tipos_instituicoes = tipos_instituicoes.data;
    this.$emit("options", this.tipos_instituicoes);
  },
};
</script>

<style>
</style>
